import { render, staticRenderFns } from "./report-record.vue?vue&type=template&id=32208114&scoped=true"
import script from "./report-record.vue?vue&type=script&lang=js"
export * from "./report-record.vue?vue&type=script&lang=js"
import style0 from "./report-record.vue?vue&type=style&index=0&id=32208114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32208114",
  null
  
)

export default component.exports